import { t } from 'i18next';
import { call, put, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getUserSettings, patchUserSettings } from './data';
import { errorReceiveModifyUserSettings, errorReceiveUserSettings, failedReceiveModifyUserSettings, failedReceiveUserSettings, receiveModifyUserSettings, receiveUserSettings } from './slice';
export function* requestModifyUserSettings(action) {
    try {
        const { consumerAPI, userSettings } = action.payload;
        const response = yield call(patchUserSettings, userSettings, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveModifyUserSettings());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_USER_SETTINGS', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveModifyUserSettings(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_USER_SETTINGS', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_USER_SETTINGS', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveModifyUserSettings());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_USER_SETTINGS', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveModifyUserSettings(response.data, consumerAPI));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_USER_SETTINGS', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_USER_SETTINGS', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveModifyUserSettings());
    }
}
export function* requestUserSettings(action) {
    try {
        const { consumerAPI } = action.payload;
        const response = yield call(getUserSettings, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveUserSettings());
            }
            else if (data) {
                yield put(receiveUserSettings(data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveUserSettings());
            }
            else if (response && response.status === 200) {
                yield put(receiveUserSettings(response.data, consumerAPI));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveUserSettings());
    }
}
export function* watchRequestModifyUserSettings() {
    yield takeLatest('userSettings/requestModifyUserSettings', requestModifyUserSettings);
}
export function* watchRequestUserSettings() {
    yield takeLatest('userSettings/requestUserSettings', requestUserSettings);
}
